import { SideItemOption, SideItemType } from '~/core/enums';

// Backwards compatibility - keep existing array
export const SIDE_ITEMS = [
  SideItemType.WALL_SIDE,
  SideItemType.APPLIANCE_SIDE,
  SideItemType.WATERFALL,
];

// Laminate-specific side items
export const LAMINATE_SIDE_ITEMS = [
  SideItemType.END_CAP,
  SideItemType.END_SPLASH,
];

// Material-aware function
export const getSideItems = (isLaminate: boolean): SideItemType[] =>
  isLaminate ? [...SIDE_ITEMS, ...LAMINATE_SIDE_ITEMS] : SIDE_ITEMS;

export const SIDE_ITEM_OPTIONS = [
  SideItemOption.BACKSPLASH,
  SideItemOption.WATERFALL,
];
